export default __webpack_public_path__ + "static/media/thank-you.48f88786.jpg";